import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'

const MerkleTreePOR = () => {
  return (
    <>
      <Helmet>
        <title>Merkle Tree Proof of Reserves - Proof of Reserves Auditor</title>
        <meta name="description" content="Cryptographic verification using Merkle tree technology for privacy-conscious platforms." />
      </Helmet>

      <div className="service-page">
        <section className="relative section-padding bg-gradient-to-br from-primary to-primary-800 text-white">
          {/* Background Image */}
          <div className="absolute inset-0">
            <img
              src="/cpaservices.jpg"
              alt="CPA Services Background"
              className="w-full h-full object-cover"
            />
            {/* Dark overlay for text readability */}
            <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          </div>
          <div className="container-custom relative z-10">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Merkle Tree Proof of Reserves</h1>
            <p className="text-xl text-gray-200 max-w-3xl">
              Cryptographic verification using Merkle tree technology for privacy-preserving verification
            </p>
          </div>
        </section>

        <section className="section-padding bg-white">
          <div className="container-custom max-w-4xl">
            <h2 className="section-title">Overview</h2>
            <p className="text-lg text-gray-600 mb-6">
              Our Merkle Tree Proof of Reserves allows your users to independently verify their balances are included in total reserves. This cryptographic approach provides mathematical proof without exposing individual account details, ensuring both transparency and privacy.
            </p>

            <h2 className="section-title mt-12">Key Features</h2>
            <ul className="list-disc list-inside text-lg text-gray-600 space-y-2 mb-8">
              <li>Privacy-preserving verification</li>
              <li>User-verifiable cryptographic proofs</li>
              <li>No exposure of individual balances</li>
              <li>Mathematical certainty of inclusion</li>
              <li>Real-time verification capability</li>
              <li>Industry-standard implementation</li>
            </ul>

            <h2 className="section-title mt-12">How It Works</h2>
            <p className="text-lg text-gray-600 mb-6">
              Each user receives a unique cryptographic proof that allows them to verify their balance is included in the total reserve calculation. The Merkle tree structure ensures that no individual balances are exposed while still providing verifiable transparency.
            </p>

            <h2 className="section-title mt-12">Benefits</h2>
            <ul className="list-disc list-inside text-lg text-gray-600 space-y-2 mb-8">
              <li>Enhanced user trust through self-verification</li>
              <li>Protection of user privacy</li>
              <li>Reduced dependency on third-party auditors</li>
              <li>Continuous verification availability</li>
              <li>Cost-effective compliance solution</li>
            </ul>

            <div className="mt-12 text-center">
              <Link to="/contact" className="btn-primary">
                Request a Quote
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default MerkleTreePOR